var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frontPage"},[_c('p',[_vm._v(_vm._s(_vm.initText))]),_c('p',[_vm._v(_vm._s(_vm.initText2))]),_c('button',{on:{"click":_vm.toRoute}},[_vm._v("点击后跳转")]),_c('p',[_c('audio',{ref:"audiosF",attrs:{"controls":"","height":"50","src":require("./audio/introduce_bg.mp3")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }